import React from 'react'
import { Chip } from '@arnsbogroup/react-voicearchive'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

const UsageStatusChip = ({
  task = [],
  USAGE_TYPE_ID = 12,
  includeFullUsage = false,
  airingTimeText = null,
  mediaText = null,
  territoryMarketText = null,
  forceIndividualStatus = false,
  reminderDisabled = false,
}) => {

  const isUsageTask = task.type == USAGE_TYPE_ID || task.type?.uid == USAGE_TYPE_ID || task.type === "USAGE"

  if (!isUsageTask) {
    return null
  }

  const { formatMessage } = useIntl()

  const {
    isUsageExtension = null,
    hasUsageExtensions = null,
    usageTaskStatus = null,
    usageTaskDaysUntilStart = null,
    usageExtensionCount = null,
    usageRemainingDays = null,
    uid = null,
    slug = null
  } = task?.usage || {}
  const airing_time_start = task?.airing_time_start

  const isInPerpetuity = slug == "in_perpetuity"

  const usagePrefix = includeFullUsage && airingTimeText && mediaText && territoryMarketText
    ? `${airingTimeText} - ${mediaText} - ${territoryMarketText} ${isInPerpetuity ? '' : " ・ "}`
    : ''
  return (
    <>
      {(!hasUsageExtensions || forceIndividualStatus) && usageTaskStatus &&
        <>
          { usageTaskStatus === 'pending' && usageTaskDaysUntilStart &&
            <Chip size="xs" className="ml-1">
              {usagePrefix}<FormattedMessage {...messages.startsIn} />{usageTaskDaysUntilStart}<FormattedMessage {...messages.days} />
            </Chip>
          }
        </>
      }

      { hasUsageExtensions && !forceIndividualStatus &&
        <>
          <Chip size="xs" state="info" className="ml-1">
            {usagePrefix}{usageExtensionCount} <FormattedMessage {...messages.extension} />
          </Chip>
        </>
      }

      { isInPerpetuity && airing_time_start > 0 && usageTaskStatus === 'active' &&
        <Chip size="xs" state="info" className="ml-1">
          {usagePrefix} {includeFullUsage ? '' : formatMessage(messages.inPerpetuity)}
        </Chip>
      }

      { forceIndividualStatus && hasUsageExtensions && usageTaskStatus === 'expired' && airing_time_start > 0 &&
        <Chip size="xs" state="error" className="ml-1">
          {usagePrefix}{formatMessage(messages.expired)}
        </Chip>
      }

      { !isInPerpetuity && usageRemainingDays !== undefined && usageRemainingDays !== null && airing_time_start > 0 && usageTaskStatus !== 'pending' && !(forceIndividualStatus && hasUsageExtensions && usageTaskStatus === 'expired') &&
        <Chip
          size="xs"
          state={usageRemainingDays > 14 ? 'info' : (usageRemainingDays > 0 ? 'warning' : 'error')}
          className="ml-1"
        >
          {usagePrefix}{usageRemainingDays > 0
            ? `${usageRemainingDays}${formatMessage(messages.daysLeft)}`
            : formatMessage(messages.expired)
          }
        </Chip>
      }

      { reminderDisabled &&
        <Chip size="xs" state="warning" className="ml-1">
          <FormattedMessage {...messages.reminderDisabled} />
        </Chip>
      }
    </>
  )
}

export default UsageStatusChip
